import React from 'react';
import styled from 'styled-components';
import { IoIosArrowBack } from 'react-icons/io';
import { BsCheckLg } from 'react-icons/bs';

type Props = {
  images: any[];
  onSelect: (stc: string) => () => void;
  currentImage?: { src: string };
};

export function ManualImageSelectInner({
  images,
  onSelect,
  currentImage,
}: Props) {
  const getDisplayImages = () => {
    if (images && images.length > 0) return images;
    if (currentImage) return [currentImage];
    return [];
  };

  const displayImages = getDisplayImages();
  const currentImageSrc = currentImage?.src;

  if (displayImages.length === 0) {
    return (
      <EmptyState>
        <p>No images available for this product</p>
      </EmptyState>
    );
  }

  return (
    <Grid>
      {displayImages.map(({ src }) => {
        const isSelected = currentImageSrc === src;
        return (
          <Box key={src} onClick={onSelect(src)} isSelected={isSelected}>
            <img src={src} alt="pic" />
            {isSelected && (
              <CheckmarkBadge>
                <BsCheckLg size={16} color="white" />
              </CheckmarkBadge>
            )}
          </Box>
        );
      })}
    </Grid>
  );
}

const Box = styled.div`
  position: relative;
  width: 240px;
  border: ${(p: { isSelected?: boolean }) =>
    p.isSelected ? `2px solid #000000` : `1px solid #969696`};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: ${(p: { isSelected?: boolean }) =>
    p.isSelected
      ? `0 2px 8px 0 rgba(0, 0, 0, 0.3), 0 2px 8px 0 rgba(0, 0, 0, 0.2)`
      : `0 1px 4px 0 rgba(0, 0, 0, 0.09), 0 1px 4px 0 rgba(7, 6, 6, 0.04)`};
  &:hover {
    cursor: pointer;
    opacity: 0.6;
  }
  &:active {
    cursor: default;
    opacity: 1;
    box-shadow: none;
  }
  img {
    width: 100%;
  }
`;

const CheckmarkBadge = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  background-color: #000000;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
`;

const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  min-height: 20rem;

  p {
    font-size: 1.6rem;
    color: #5b656e;
    text-align: center;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 2rem;
`;

export function ManualImageSelectHeaderInner({
  onBack,
}: {
  onBack: () => void;
}) {
  return (
    <HeaderStyled>
      <Back type="button" onClick={onBack}>
        <IoIosArrowBack color="grey" size={40} />
      </Back>
      <p>Please select the preferred product image</p>
    </HeaderStyled>
  );
}

const HeaderStyled = styled.div`
  position: relative;
  width: 100%;

  p {
    font-size: 3rem;
    margin: 1rem 0 1rem 0;
  }
`;
const Back = styled.button`
  &:hover {
    cursor: pointer;
    opacity: 0.3;
  }
  &:active {
    cursor: pointer;
    opacity: 0.5;
  }
  opacity: 0.5;
  left: 20px;
  position: absolute;
  top: -30px;
  color: #d2d4d7;
`;
